import React from "react";

export interface DashboardContextValueInterface {
    showNotifications: boolean;
    showParamsCard: boolean;
    isPastForecastExpandedParamsCard: boolean;
    isExpandedParamsCard: boolean;
    selectedSensors: any[];
    selectedLocation: string;
    infraToShow: any;
    expandLeftMenu: boolean;
    selectedDate: [any, any];
    kpi: any[];
    fetchDashboardDataIndex: number;
    activatedDigitalTwinMode?: boolean;
    activatedInflowMode?: boolean;
    activatedMmsMode?: boolean;
    activatedHeatmapMode?: boolean;
    activatedPastOverflowMode?: boolean;
    activatedSewerAnalysisMode?: boolean;
    activatedSensorMaintenanceMode?: boolean;
    activatedAlertMode?: boolean;
    selectedMmsId?: string;
    selectedMmsFileName?: string;
    simulationId?: string;                
    simulationGroupName?: string;         
    simulationStatus?: 'idle' | 'running' | 'completed' | 'failed'; 
    lastCompletedSimulationId?: string;   
    lastCompletedGroupName?: string;      
    mmsCheckedAssets?: Array<{ assetId: string; assetType: 'NODE' | 'LINK' }>; 
    notificationCount?: number;
    compactCardHeight?: number;
}

export interface DashboardContextInterface {
    value: DashboardContextValueInterface;
    setValue: React.Dispatch<
        React.SetStateAction<DashboardContextValueInterface>
    >;
}

const initialContext: DashboardContextInterface = {
    value: {
        showNotifications: false,
        showParamsCard: false,
        isPastForecastExpandedParamsCard: true,
        isExpandedParamsCard: true,
        selectedSensors: [],
        selectedLocation: "",
        infraToShow: null,
        expandLeftMenu: false,
        selectedDate: [new Date(), new Date()],
        kpi: [],
        fetchDashboardDataIndex: 0,
        activatedDigitalTwinMode: false,
        activatedInflowMode: false,
        activatedMmsMode: false,
        activatedHeatmapMode: false,
        activatedPastOverflowMode: false,
        activatedSewerAnalysisMode: false,
        activatedSensorMaintenanceMode: false,
        activatedAlertMode: false,
        selectedMmsId: undefined,
        selectedMmsFileName: undefined,
        mmsCheckedAssets: [],              
        compactCardHeight: 300,
    },
    setValue: () => { },
};

const DashboardContext = React.createContext(initialContext);

export default DashboardContext;
